import { useContext } from 'react';
import { AccountsContext } from './AccountsProvider';

export const useAccountContext = () => {
  const context = useContext(AccountsContext);
  if (context === undefined) {
    throw new Error('useAccountContext must be used within a AccountsProvider');
  }
  return context;
};
